import * as React from 'react';

import { Button } from '@mq/aurora-components/dist/button';

import * as styles from './category.css';

export class Category extends React.PureComponent<{}, {}> {
  handleDiscoverMarqueeRoute = () => {
    window.location.href = 'https://marquee.gs.com/s/discover';
  };

  handleContactSalesRoute = () => {
    const mailTo: string = 'gs-marquee-sales@gs.com';
    const subject: string = 'Request access to Marquee';
    const body: string = 'I would like to learn more about Marquee.';

    window.location.href = `mailto:${mailTo}?subject=${subject}&body=${body}`;
  };

  render() {
    return (
      <div className={styles.category}>
        <div className={styles.container}>
          <div className={styles.categoryCellStyle}>
            <h3>Learn More about Marquee</h3>
            <p>
              Marquee is the future of digital finance, delivered by the Securities Division of
              Goldman Sachs.
            </p>
            <Button
              onClick={this.handleDiscoverMarqueeRoute}
              style={{ maxWidth: '180px', width: '100%' }}
            >
              Discover Marquee
            </Button>
          </div>
          <div className={styles.categoryCellStyle}>
            <h3>Need Assistance?</h3>
            <p>
              If the content you’re accessing is no longer available, please contact Marquee Sales
              for support.
            </p>
            <Button
              onClick={this.handleContactSalesRoute}
              style={{ maxWidth: '180px', width: '100%' }}
            >
              Contact Marquee Sales
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
